import {ReactElement, useState} from "react";
import {useNavigate} from "react-router-dom";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from "@mui/material/Stack";
import Box from '@mui/material/Box';
import {useIdentity} from '../../hooks/useIdentity';
import {Navigate} from "react-router-dom";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    width: 400,
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    p: 4,
};

const Login = (): ReactElement => {
    const [userName, setUserName] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const navigate = useNavigate();
    const [token, isAuthenticated, updateToken] = useIdentity();

    const login = async (): Promise<void> => {
        const result = await fetch(`/api/v1/Users/Authorize`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                userName,
                password
            })
        });

        if (result.status == 200) {
            setUserName("");
            setPassword("");
            const token = await result.json();
            // @ts-ignore
            updateToken(token.result.token);
            navigate("/applications");
            return;
        } else return;
    };

    return (
        <>
            {isAuthenticated && <Navigate to={'/applications'}/>}
            <Box sx={style}>
                <Stack
                    onSubmit={(e: any) => {
                        e.preventDefault();
                        login().then();
                        return false;
                    }}
                    component="form"
                    noValidate
                    autoComplete="off"
                    spacing={3}
                >
                    <TextField id="outlined-basic" required value={userName}
                               onChange={e => setUserName(e.currentTarget.value)} label="Username" variant="outlined"/>
                    <TextField id="outlined-basic" required value={password}
                               onChange={e => setPassword(e.currentTarget.value)} label="Password" variant="outlined"/>
                    <Button variant="contained" type="submit">Login</Button>
                </Stack>
            </Box>
        </>
    );
};

export default Login;